import { memo, useMemo } from 'react'
import { Chip, Stack, Typography } from '@mui/material'
import { useOrganizationsContext } from '@/components/organizations/OrganizationsProvider'

type OrgCellProps = {
  orgId: string
}

function OrgCell({ orgId }: OrgCellProps) {
  const { organizations } = useOrganizationsContext()

  const { org, parentOrg } = useMemo(() => {
    const tempOrg = organizations?.find((org) => org.id === orgId)

    const tempParentOrg = tempOrg
      ? organizations?.find((org) => org.id === tempOrg.parent_org_id)
      : null

    return {
      org: tempOrg,
      // We don't show the root organization as a parent
      parentOrg:
        tempParentOrg && tempParentOrg.parent_org_id ? tempParentOrg : null,
    }
  }, [organizations, orgId])

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="inherit">{org?.name}</Typography>
      {parentOrg && (
        <Chip
          label={parentOrg.name}
          size="small"
          variant="outlined"
          sx={{
            '.MuiChip-label': {
              fontSize: 11,
            },
          }}
        />
      )}
    </Stack>
  )
}

export default memo(OrgCell)
